export default function transformValue(value, type) {
  if (value == null) return value;

  switch (type) {
    case "number":
      return Number(value);
    case "date":
      return new Date(`${value}T00:00:00`);
    case "datetime":
      return new Date(value);
    case "boolean":
      return Boolean(value);
    case "string":
      return String(value);
    case "json":
      case "array":
      return value;
    case "array":
      return value;
    default:
      throw new Error(`${type} is not a valid option in transformValue`);
  }
}
